<div dialog-header>
  <h4>
    {{
      errorInContracts ? 'Register/Decline Batch contains errors.' : 'Contracts successfully registered or declined!'
    }}
  </h4>
  <button class="close-btn" (click)="close()">
    <app-icon name="cross" width="16px" height="16px" />
  </button>
</div>

@if (!errorInContracts) {
  <app-icon name="circle_checkmark" width="75px" height="75px" />
  <p>Contracts have been successfully registered or declined. To view history or undo decline go to history tab.</p>
} @else {
  <app-icon name="circle_warning" width="75px" height="75px" />
  <div class="errors-block">
    @for (error of displayErrors; track error) {
      <div>
        <p>{{ error.name }}</p>
        <p>{{ error.error }}</p>
      </div>
    }
  </div>
  <p>Please contact Dealer Support for information on next steps.</p>
}

<div dialog-actions>
  @if (atLeastOneSuccessfulContract) {
    <button ui-button type="info" (click)="exportClicked()">Export</button>
    <button ui-button type="info" (click)="printRemit()">Print</button>
  }
  <button ui-button type="secondary" (click)="close()">Continue</button>
</div>
